import store from "@/store";
import router from "@/router";
import { SUPER_SEARCH_KEY, DEFAULT_TAB_PARAM } from "@/utils/constants/constants.search-filter";
import { getProgIdAndNoticeSegmentTypeMaps } from "@/utils/searchUtil";

import { TYPE_TENDER_JSON, TYPE_WINBIDDING_JSON } from "@/assets/typeTenderJSON.js";

import { IsNull } from "@/utils/common";
const OLD_SEARCH_URL = process.env.VUE_APP_OLD_SEARCH_URL;
const urlAddressDataProcessing = () => {
  let paramsData = {};
  let schoseParams = { SuperSearchValue: {} };
  router.beforeEach((to, from, next) => {
    // 判断是不是从search跳过来的document.referrer.includes(OLD_USER_CENTER_SEARCH_URL)
    // 不加 document.referrer.includes(OLD_USER_CENTER_SEARCH_URL) 会判断失误
    // 重构项目页面互跳也会掉进if，不对
    if (
      document.referrer.includes(OLD_SEARCH_URL) && //放开
      !to.query.fromSearch &&
      !IsNull(to.query)
    ) {
      // 这里老项目加上要改掉
      let queryData = to.query;
      for (let key in queryData) {
        /*处理参数类型，sting=>bumber*/
        queryData[key] = stringVariableNumber(queryData[key], key);
        switch (key) {
          case "tab_index":
            switch (queryData.tab_index) {
              case 0: {
                paramsData.allType = queryData.allType;
                paramsData.progIdAndNoticeSegmentTypeMaps = {};
                let list = queryData.allType + "";
                list.split(",").forEach((item) => {
                  if (item > -1) {
                    paramsData.progIdAndNoticeSegmentTypeMaps[item] = [];
                  }
                });

                break;
              }
              case 1: {
                paramsData.progIdAndNoticeSegmentTypeMaps = getProgIdAndNoticeSegmentTypeMaps(
                  TYPE_TENDER_JSON,
                  queryData
                );
                if (paramsData.progIdAndNoticeSegmentTypeMaps["4"]) {
                  paramsData.progIdAndNoticeSegmentTypeMaps["4"] = [2, 3, 5];
                }

                break;
              }
              case 2: {
                paramsData.allType = queryData.tab_index;

                paramsData.progIdAndNoticeSegmentTypeMaps = getProgIdAndNoticeSegmentTypeMaps(
                  TYPE_WINBIDDING_JSON,
                  queryData
                );

                break;
              }
              case 3: {
                paramsData.allType = queryData.tab_index;
                let listd = queryData.jzjd + "";
                listd.split(",").forEach((item) => {
                  if (item > -1) {
                    paramsData.progIdAndNoticeSegmentTypeMaps[item] = [];
                  }
                });
                break;
              }
              case 4:
                {
                  paramsData.allType = queryData.tab_index;
                  let listdd = queryData.types + "";
                  listdd.split(",").forEach((item) => {
                    if (item > -1) {
                      paramsData.progIdAndNoticeSegmentTypeMaps[item] = [];
                    }
                  });
                }
                break;
            }
            break;
          default:
            paramsData[key] = queryData[key];
            schoseParams[key] = {
              id: queryData[key],
            };
        }
        if (queryData.tab_index > 0) {
          paramsData.allType = "-1";
          schoseParams.allType = {
            id: "-1",
          };
        }
        if (SUPER_SEARCH_KEY.includes(key)) {
          schoseParams.SuperSearchValue = {
            ...schoseParams.SuperSearchValue,
            ...{ [key]: { id: queryData[key] } },
          };
        }
      }

      // store.commit("search/updateSearchChoseParams", {
      //   ...DEFAULT_TAB_CHOSE_PARAM[queryData.tab_index || 0],
      //   ...schoseParams,
      // });
      store.commit("search/updateSearchParams", {
        ...DEFAULT_TAB_PARAM[queryData.tab_index || 0],
        ...paramsData,
      });
      queryData.tabId = queryData.tab_index || 0;
      queryData.keywords = queryData.keywords || "";
      delete queryData.tab_index;
      queryData.fromSearch = new Date().getTime(); //  document.referrer   next()没有更改来源所以需要 一个标识来区分，不然一直进这里 // todo 继续改 还不可以
      next({ path: to.path, query: queryData, replace: true });
    }

    next();
  });
};
function stringVariableNumber(val, key) {
  let noIncludNumber = [
    "relatedWord",
    "excludeWord",
    "fourLevelCategoryIdListStr",
    "threeLevelCategoryIdListStr",
    "purchasingUnitIdList",
    "areas",
    "beginTime",
    "endTime",
    "starNums",
    "tenderOrBidderName",
    "types",
    "noticeSegmentTypeStr",
  ];
  var regPos = /^[0-9]+.?[0-9]*/; //判断是否是数字。
  if (regPos.test(val) && !noIncludNumber.includes(key)) {
    val = Number(val);
  }
  return val;
}

export default urlAddressDataProcessing;
